import {
  MemberPetition,
  MemberPetitionStatus,
  PetitionType,
} from '../types/petition';

/** API may return enums as strings via JsonStringEnumConverter. */
export function normalizePetitionStatus(
  status: MemberPetitionStatus | string | number | undefined | null
): MemberPetitionStatus {
  if (typeof status === 'number') {
    if (
      status === MemberPetitionStatus.Pending ||
      status === MemberPetitionStatus.Approved ||
      status === MemberPetitionStatus.Rejected
    ) {
      return status;
    }
    return MemberPetitionStatus.Pending;
  }

  if (typeof status === 'string') {
    const map: Record<string, MemberPetitionStatus> = {
      Pending: MemberPetitionStatus.Pending,
      Approved: MemberPetitionStatus.Approved,
      Rejected: MemberPetitionStatus.Rejected,
      '1': MemberPetitionStatus.Pending,
      '2': MemberPetitionStatus.Approved,
      '3': MemberPetitionStatus.Rejected,
    };
    return map[status] ?? MemberPetitionStatus.Pending;
  }

  return MemberPetitionStatus.Pending;
}

export function normalizePetitionType(
  type: PetitionType | string | number | undefined | null
): PetitionType {
  if (typeof type === 'number') {
    if (type === PetitionType.LostMemberCard || type === PetitionType.ChangeMembershipType) {
      return type;
    }
    return PetitionType.LostMemberCard;
  }

  if (typeof type === 'string') {
    const map: Record<string, PetitionType> = {
      LostMemberCard: PetitionType.LostMemberCard,
      ChangeMembershipType: PetitionType.ChangeMembershipType,
      '1': PetitionType.LostMemberCard,
      '2': PetitionType.ChangeMembershipType,
    };
    return map[type] ?? PetitionType.LostMemberCard;
  }

  return PetitionType.LostMemberCard;
}

export function normalizeMemberPetition(petition: MemberPetition): MemberPetition {
  return {
    ...petition,
    status: normalizePetitionStatus(petition.status),
    petitionType: normalizePetitionType(petition.petitionType),
  };
}
